import React, {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'

export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const PublicationsPage = lazy(() => import('../modules/publications/PublicationsPage'))
  const ReportPage = lazy(() => import('../modules/report/ReportPage'))
  const CVPage = lazy(() => import('../modules/cv/CVPage'))
  const WIP = lazy(() => import('../pages/wip'))

  return (
      <Suspense fallback={<FallbackView />}>
        <Switch>
          <Route path='/dashboard' component={DashboardWrapper} />
          <Route path='/publications' component={PublicationsPage} />
          <Route path='/cv' component={CVPage} />
          <Route path='/profile' component={ProfilePage} />
          <Route path='/report' component={ReportPage} />
          <Route path='/wip' component={WIP} />
          <Route path='/builder' component={BuilderPageWrapper} />

          <Redirect from='/custom-report' to='/wip' />
          <Redirect from='/overview-report' to='/wip' />

          <Redirect from='/auth' to='/dashboard' />
          <Redirect exact from='/' to='/dashboard' />
          <Redirect to='error/404' />
        </Switch>
      </Suspense>
  )
}
